/**
 * Copyright
 */
export const copyRight = () => `© 2015-${new Date().getFullYear()} `

/**
 * CSS
 */

export const fullWidth = true

export const margin = 'normal'

/**
 * Redirection
 */

export const redirectTo = {
  dashboard: '/dashboard',
  login: '/login',
  launchpad: 'launchpad',
}
/**
 * API constants
 */

export const token = 'token'
export const session = 'session'
export const datasets = 'datasets'
export const optimizations = 'optimizations'
export const talents = 'employees'
export const importHistory = 'import_history'
export const datasetOverview = 'overview'
export const grades = 'grades'
export const languages = 'languages'
export const workOpportunities = 'bookings'
export const templates = 'templates'
export const kpi = 'kpi'
export const optimization = 'optimization'
export const group = 'group'
export const defaults = 'defaults'
export const compare = 'compare'
export const dataset = 'dataset'
export const jobManagers = 'job_managers'
export const employees = 'employees'
export const skills = 'skills'
export const plannings = 'plannings'

/**
 * API Endpoints
 */

export const apiEndPoints = {
  token,
  session,
  datasets,
  optimizations,
  talents,
  importHistory,
  datasetOverview,
  grades,
  languages,
  workOpportunities,
  static: 'static',
  templates,
  kpi,
  dataset,
  optimization,
  group,
  defaults,
  compare,
  jobManagers,
  employees,
  skills,
  plannings,
}

/**
 * Methods
 */

export const method = {
  post: 'post',
  get: 'get',
  delete: 'delete',
  put: 'put',
}

/**
 * Input field
 */

export const fileFormatSelect = 'File Format'

export const startYear = 'FY'

export const accept =
  '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.ms-excel.sheet.macroEnabled.12'

export const successStatus = [200, 201, 204]

export const notEmptyOrNull = 'notEmptyOrNull'

export const yearWithPrefix = 'yearWithPrefix'

export const zipCode = 'zipCode'

export const password = 'password'

export const email = 'email'

export const confirmPasswordConst = 'confirmPassword'

export const number = 'number'

export const stringValidation = 'stringValidation'

/**
 * Button
 */
export const startOptimization = 'Start Optimization'

export const startDataImport = 'Start Data Import'

export const addDataset = 'Add Dataset'

export const addTalent = 'Add Talent'

export const editTalent = 'Update'

export const updateExcludeInclude = 'Update Include/ Exclude'

export const startNewOptimization = 'Start New Optimization'

export const latestReport = `${new Date().toISOString()} Test UAT - Full Optimization`

/**
 * Dashboard
 */

export const noOptimizationDataAvailable = 'Create new optimization'

/**
 * Extra constants
 */

export const success = 'SUCCESSFUL'

export const started = 'STARTED'

export const failed = 'FAILED'

export const inprogress = 'INPROGRESS'

export const y = 'YES'

export const n = 'NO'

export const importStatus = ['SUCCESSFUL', 'FAILED', 'INPROGRESS', 'STARTED']
